import React from "react";
import { Text } from "@jsq/ds/core";
import { overlayStyle } from "./styles_vanilla.css";

export type NoRowsOverlayProps = {
  message: string;
};

const NoRowsOverlay: React.FC<NoRowsOverlayProps> = ({ message }) => {
  return (
    <div className={overlayStyle}>
      <Text variant="regular-lg" align="center">
        {message}
      </Text>
    </div>
  );
};

export default NoRowsOverlay;
